import styled, { css } from 'styled-components';

type ContainerProps = {
  isChecked: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  overflow: hidden;
  height: 28px;

  > div {
    font-family: 'Sora', sans-serif;
    display: flex;
    color: #a6a6a6;
    padding: 4px 10px;
    align-items: center;
    justify-content: center;
    border: 1px solid #dcdcdc;
    background-color: #f2f2f2;
    cursor: pointer;
    font-size: 13px;
    font-weight: 400;
  }

  > div:first-child {
    border-right: none;
    border-radius: 5px 0px 0px 5px;

    ${({ isChecked }) =>
    !isChecked &&
    css`
        color: #ffffff;
        background-color: #f64444;
      `};
  }

  > div:last-child {
    border-left: none;
    border-radius: 0px 5px 5px 0px;

    ${({ isChecked }) =>
    isChecked &&
    css`
        color: #ffffff;
        background-color: #329bfc;
      `};
  }

  span {
    background-color: #dcdcdc;
    height: auto;
    width: 1px;
    order: 0;
  }
`;
